<template>
  <div class="video view-style">
    <el-header />
    <!-- 返回按钮区域 -->
    <div class="back-button">
      <el-button title="返回" route="/home" />
    </div>
    <div class="video-content">
      <div class="block" height="100%"> 
        <!-- elementui的走马灯, -->
        <el-carousel arrow="never" :autoplay="false" height="100%" trigger="click">
          <!-- 当点击1按钮展示的页面 -->
            <div class="obsever-area-box">
            <ul style="display: flex; align-content: flex-start; flex-wrap: wrap">
              <li
                style="width:320px; height:240px; "
               v-for="(item,index) in data"
                  v-if="data&&data.length>0" class="item-li">
                  <span>{{getorgName(item.orgId)}}</span>
                <iframe 
                  id="show-iframe"
                  :src="`http://videoflow.cloud.zhenyuanma.com/?deviceCode=${item.deviceId}${item.channelNo?item.channelNo:''}&height=240&e_names=${item.deviceName}`"
				  width="320"
				  height="240"
				  allowfullscreen="true"
                ></iframe>
              </li>
            
            </ul>
          </div>
          <!-- 当点击6按钮展示的页面 -->
          <!-- <div v-if="item === 2" class="obsever-area-box">
              <ul style="display: flex; align-items: flex-start; flex-wrap: wrap">
                <li style="width:33%; height: 50%" v-for="(item, index) in renderArr" :key="index">
                  <video-player v-if="item.playerOptions" :options="item.playerOptions"></video-player>
                </li>
              </ul>
          </div>-->
          <!-- 当点击9按钮展示的页面 -->
          <!-- <div class="obsever-area-box">
            <ul style="display: flex; align-content: flex-start; flex-wrap: wrap">
              <li
                style="width:33%; height: 33%; "
                v-for="(item,index) in data.suyuanVideoDataNodes"
                v-if="data.suyuanVideoDataNodes&&data.suyuanVideoDataNodes.length>0"
              >
                <video-player :options="item.playerOptions"  v-if="show"></video-player>
                <iframe v-else
                  id="show-iframe"
                  :src="'http://videoflow.cloud.zym.so/?deviceCode='+item.deviceId"
                ></iframe>
              </li>
            
            </ul>
          </div> -->
          <!-- 按钮区域 -->
          <!-- <div class="changebutton">
            <div>1</div>
            <div>6</div>
            <div>9</div>
          </div>-->
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
//引入header
import elHeader from "../components/Header";
//引入公共按钮组件,
import elButton from "@/components/Button";
import {pushStream,getMonitorInfo} from "../api/video.js";
//引入直播流的videoPlayer依赖
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import {mapState} from "vuex";
export default {
  components: {
    elHeader,
    elButton,
    videoPlayer
  },
  data() {
    return {
      show:true,
      //乾县地区的视频id数组
      videoOrgIdArr: [],
      //promise.all要执行的请求
      handlerArr: [],
      //最后要渲染上页面的数据,
      renderArr: [],
      data: [],
	  num:0,
    };
  },
  async mounted() {
    this.getShow();
    this.data=[];
	await this.getVideoList();
	await this.videoOrgIdArr.forEach(o=>{
		this.getLists(o)
	});
  },
  computed:{
	  ...mapState(['syEnterpriseList'])
  },
  methods: {
  getorgName(orgId)
  {
    let name="摄像头"
    if(window.sessionStorage.getItem("orgList")&&window.sessionStorage.getItem("orgList")!="")
    {
      let list=JSON.parse(window.sessionStorage.getItem("orgList"));
      list.forEach(o=>{
        
        if(orgId==o.org_id)
        {
          name= o.org_name;
        }
      })
      }
    return name;
  },
	async getVideoList()
	{
		let data = this.syEnterpriseList;
		if(typeof data == 'string')
		{
			data = await JSON.parse(data)
		}
		if(data && data != '')
		{
			await data.forEach(item => {
				this.videoOrgIdArr.push(item.org_id)
			});
		}
	},
    getShow() {
      var userAgent = navigator.userAgent;
      var isOpera = userAgent.indexOf("Opera") > -1;
      let client = {
        weixin: /micromessenger/gi.test(navigator.userAgent),
        app: /cnhnb/gi.test(navigator.userAgent),
        ios:
          /cnhnb/gi.test(navigator.userAgent) &&
          /ios/gi.test(navigator.userAgent),
        android:
          /cnhnb/gi.test(navigator.userAgent) &&
          /android/gi.test(navigator.userAgent),
        pc: /windows/gi.test(navigator.userAgent)
      };
      if (client.pc) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
 
    getStream(deviceId) {
      let data = {
        deviceId: deviceId
      };
	   pushStream(data)
        .then(res => {
		  let vue = this;
          if (res.data.code == 0 && res.data == true) {
            console.log("推流成功");
			this.num = 0;
            window.setTimeout(function() {
              vue.getStream(deviceId);
            }, 1700*1000);
          }
		  else
		  {
			  if(this.num < 5)
			  {
				  this.num ++;
				  setTimeout(() => {
				  	vue.getStream(deviceId);  
				  },5000)
			  }
			  
		  }
        });
    },

    getLists(orgId) {
        getMonitorInfo(orgId)
        .then(res => {
         if (res.data.suyuanVideoDataNodes) {
            res.data.suyuanVideoDataNodes.forEach(o=>{
              o.orgId=orgId;
              this.data.push(o);
            });
            this.data.forEach(o => {
           
              this.getStream(o.deviceId);
              o.playerOptions = {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: true, //如果true,浏览器准备好时开始回放。
                controls: true, //控制条
                preload: "auto", //视频预加载
                muted: false, //默认情况下将会消除任何音频。
                loop: false, //导致视频一结束就重新开始。
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                  {
                    headers: {
                      "Access-Control-Alow-Orogin": "*"
                    },
                    type: "application/x-mpegURL",
                    src: o.videoResource
                  }
                ],
                width: document.documentElement.clientWidth,
                notSupportedMessage: "此视频暂无法播放，请稍后再试" //允许覆盖Video.js无法播放媒体源时显示的默认信息。
              };
            });
          }
        })
        .catch(err => {});
    },
  }
};
</script>

<style lang='less'>
//引入主色调css
@import "../assets/css/mainColor.less";
.video {
  pointer-events: all;
}
.video-content {
  width:1370px;
  margin: 20px auto 0;
  height: 80%;
  pointer-events: all;
  .obsever-area-box {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    background-color: rgba(0, 0, 0, 0.7);
    &::-webkit-scrollbar {
      border-radius: 10px;
      width: 10px;
      background-color: #0A1E34;
      height: 10px;
    }
    //修改滚动条内部小方块样式
    &::-webkit-scrollbar-thumb {
      background-color: #4CC6F7;
      border-radius: 10px;
    }
    ul {
      width: 100%;
      height: 100%; 
    }
	li{
		margin:0px 20px 20px 0px;
	}
  }
}
.item-li{
	position: relative;
	overflow: hidden;
}
.item-li span{
	z-index: 100;
	position: absolute;
	left:10px;
	top: 10px;
	color: #ffffff;
	background:rgba(0,0,0,0.6);
	padding: 5px;
}
.back-button {
  pointer-events: all;
}
// 部分elementui的样式
.block {
  height: 100%;
}
.el-carousel {
  height: 100%;
}
.el-carousel__item {
  border: 1px solid @mainColor;
  height: 93%;
}
// 修改部分video-player样式
.video-player {
  width: 100%;
  height: 100%;
  .video-js,
  .vjs-paused,
  .vjs-controls-enabled,
  .vjs-workinghover,
  .vjs-v6,
  .vjs-user-active {
    width: 100%;
    height: 100%;
  }
  .vjs-big-play-button {
    left: calc(50% - 1.5em);
    top: calc(50% - 0.7em);
    outline: none;
  }
}
// 按钮的样式
.changebutton {
  position: absolute;
  bottom: 0;
  left: calc(50% - 57px);
  z-index: 999;
  pointer-events: none;
  background-color: #29373a;
  width: 114px;
  height: 28px;
  display: flex;
  justify-content: space-around;
  div {
    flex: 1;
    text-align: center;
    line-height: 28px;
    color: @mainColor;
  }
}
</style>